// extracted by mini-css-extract-plugin
export default {"ctaSection":"wBSEatAi2un_Pl6edGw3","h1":"wex5mrVaY8C8w7yNn02z","ctaButton":"t6K3R8GxK7shG8QYhDS4","footerText":"exaeupZaygDyF3dq4hmc"};